import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'choseSeparateFiles',
    'choseSingleFile',
    'driversLicenseNotice',
    'fileBackInputBlock',
    'fileBackInputStatus',
    'fileFrontAndBackInputBlock',
    'selectedKycType',
    'singleOrSeparateFileChoiceButtons',
  ];

  connect() {
    this.toggleSingleFileOrMultipleFilesMenu(false);
  }

  toggleSingleFileOrMultipleFilesMenu(canChangeTab = true) {
    this.#showInputsIfATypeIsSelected();
    this.#toggleSingleOrSeparateFileChoiceButtons(canChangeTab);
    this.toggleFileBackInput();
  }

  toggleFileBackInput() {
    if (this.choseSeparateFilesTarget.checked && this.#canSelectedDocumentTypeHaveABack()) {
      this.fileBackInputBlockTarget.classList.remove('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = false));
      this.fileFrontAndBackInputBlockTarget.classList.add('row-cols-md-2', 'g-md-3');
      this.fileFrontAndBackStatusTarget.classList.remove('d-none');
    } else {
      this.fileBackInputBlockTarget.classList.add('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = true));
      this.fileFrontAndBackInputBlockTarget.classList.remove('row-cols-md-2', 'g-md-3');
      this.fileFrontAndBackStatusTarget.classList.add('d-none');
    }
  }

  // private

  #toggleSingleOrSeparateFileChoiceButtons(canChangeTab = true) {
    this.singleOrSeparateFileChoiceButtonsTarget.classList.toggle('d-none', !this.#canSelectedDocumentTypeHaveABack());
    if (this.#canSelectedDocumentTypeHaveABack() && canChangeTab) {
      this.choseSingleFileTarget.checked = false;
      this.choseSeparateFilesTarget.checked = true;
    }
  }

  #canSelectedDocumentTypeHaveABack() {
    return this.selectedKycTypeTarget.options[this.selectedKycTypeTarget.selectedIndex].dataset.mayHaveBack === 'true';
  }

  #showInputsIfATypeIsSelected() {
    if (this.selectedKycTypeTarget.selectedIndex == 0) {
      this.fileFrontAndBackInputBlockTarget.classList.add('d-none');
    } else {
      this.fileFrontAndBackInputBlockTarget.classList.remove('d-none');
      this.#toggleDriversLicenseNotice();
    }
  }

  #toggleDriversLicenseNotice() {
    if (this.selectedKycTypeTarget.selectedOptions[0].value == 11) {
      this.driversLicenseNoticeTarget.classList.remove('d-none');
    } else {
      this.driversLicenseNoticeTarget.classList.add('d-none');
    }
  }
}
